import { useQuery } from '@tanstack/react-query'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { RequestsHttpClient, RequestResponse } from '@omnea-app/requests/requestsHttpClient'

export const SupplierTasksQueryKey = 'supplier-tasks'

export type SupplierStep = NonNullable<RequestResponse<'/supplier-steps', 'get'>['data']>[number]
export type StepType = SupplierStep['stepType']

export const useGetSupplierSteps = () => {
  const { getToken } = useAuthenticatedUser()
  return useQuery({
    queryKey: [SupplierTasksQueryKey],
    queryFn: async () => {
      const token = await getToken()
      const apiClient = new RequestsHttpClient({ authorization: token })
      const { data, error } = await apiClient.GET('/supplier-steps')
      if (error) {
        console.error('Error fetching supplier tasks', error)
        return
      }
      return data
    },
  })
}
